// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-07519124]:export{primaryColor:#21292f;secondaryColor:#80eb07;accentColor:#df0000}.tight-sup[data-v-07519124]{font-size:1.1em;vertical-align:baseline;position:relative;top:0;letter-spacing:.02em;margin-left:-.8px}", ""]);
// Exports
module.exports = exports;
